export function parseLocalDate(dateStr) {
  if (!dateStr) return null;
  return new Date(String(dateStr).replace(/Z$/i, '').replace(/[+-]\d{2}:\d{2}$/, ''));
}
